/* eslint-env browser */

import React from 'react';
import { Section, Divider } from 'rebass';

import PageHelmet from 'frontend/components/PageHelmet';

import CharacterInputPanel from './CharacterInputPanel';
import SimcWarning from './SimcWarning';
import SubmitSimulationButton from './SubmitSimulationButton';
import RawSimcInput from './RawSimcInput';
import AdvancedSimOptions from './AdvancedSimOptions';
import CustomAplOptions from './CustomAplOptions';
import ReportOptions from './ReportOptions';

const SimbotStatWeights = () => (
  <div>
    <PageHelmet page="quick" />
    <Section pt={2} px={1}>
      <CharacterInputPanel />

      <Divider my={2} />

      <AdvancedSimOptions />

      <Divider my={2} />

      <CustomAplOptions type="quick" />

      <Divider my={2} />

      <ReportOptions type="quick" />

      <Divider my={2} />

      <RawSimcInput type="quick" />

      <SubmitSimulationButton type="quick" />

      <SimcWarning />
    </Section>
  </div>
);

export default SimbotStatWeights;
